import { ErrorBoundary } from 'react-error-boundary';

import { ErrorFallback } from '@/components/errors/ErrorFallback';

export function PageEditorErrorBoundary({ children }: { children: React.ReactNode }) {
  // Using ErrorBoundary without an explicit onReset handler, that way it can reset the internal error state of the boundary, and re-render its children from scratch.
  // This is useful when iframed in the page editor, as it allows a recovery from errors without needing to reload the iframe and lose synchronization with the builder.
  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
}
